function dataDummy({ t }: { t: (value: string) => string }) {
  const dataSearch = [
    {
      id: 1,
      title: 'Procurement Activities',
      type: 'primary',
    },
    {
      id: 2,
      title: 'Procurement Activities2',
      type: 'steering',
    },
    {
      id: 3,
      title: 'Procurement Activities3',
      type: 'support',
    },
    {
      id: 4,
      title: 'Procurement Activities4',
      type: 'primary',
    },
    {
      id: 5,
      title: 'Procurement Activities4',
      type: 'primary',
    },
    {
      id: 6,
      title: 'Procurement Activities4',
      type: 'primary',
    },
    {
      id: 7,
      title: 'Procurement Activities4',
      type: 'primary',
    },
  ];

  const dataListDelete = [
    {
      id: 1,
      title: 'Set A - Drilling Skill - Expert',
    },
    {
      id: 2,
      title: 'Set A - Drilling Skill - Expert',
    },
    {
      id: 3,
      title: 'Set A - Drilling Skill - Expert',
    },
  ];

  const dataListCreate = [
    {
      id: 1,
      title: 'Procurement Activities',
      type: 'primary',
    },
    {
      id: 2,
      title: 'Procurement Activities2',
      type: 'primary',
    },
  ];

  const dataTab = [
    {
      id: 1,
      name: 'Library',
    },
    {
      id: 2,
      name: 'Manual',
    },
  ];

  const procHierarcy = {
    id_1: '8383ebe4-b224-492e-94e6-5fb0f81cce51',
    id_2: '8383ebe4-b224-492e-94e6-5fb0f81cce52',
    id_3: '8383ebe4-b224-492e-94e6-5fb0f81cce53',
    id_4: '8383ebe4-b224-492e-94e6-5fb0f81cce54',
  };

  const listHierarcy = [
    {
      label: 'Primary Process',
      value: '8383ebe4-b224-492e-94e6-5fb0f81cce51',
    },
    {
      label: 'Steering Governance',
      value: '8383ebe4-b224-492e-94e6-5fb0f81cce52',
    },
    {
      label: 'Support Process',
      value: '8383ebe4-b224-492e-94e6-5fb0f81cce53',
    },
  ];

  const listExample = [
    {
      id: 1,
      name: t('biz_process.tree.behav_comp'),
    },
    {
      id: 2,
      name: t('biz_process.tree.tech_comp'),
    },
    {
      id: 3,
      name: t('biz_process.workload_standart'),
    },
  ];

  const newList = [
    {
      id: 3,
      name: t('biz_process.workload_standart'),
    },
  ];

  const listTree = [
    {
      id: 1,
      name: t('biz_process.tree.behav_comp'),
    },
    {
      id: 2,
      name: t('biz_process.tree.tech_comp'),
    },
  ];

  const listLevel = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 },
  ];

  return {
    dataSearch, dataListDelete, dataListCreate, dataTab, procHierarcy, listExample, listTree, newList, listHierarcy, listLevel,
  };
}

export default dataDummy;
